import VehicleDetailsSource from 'src/services/geoJson/sources/VehicleDetailsSource';
import AssetsBaseLayer from './AssetsBaseLayer';

export default class VehicleDetailsLayer extends AssetsBaseLayer {
  /** @var {String} id */
  static id = 'vehicle-details-layer';

  /**
   * @returns {Object} A GeoJson layer config object.
   */
  getConfig() {
    const parentConfig = super.constructor.getConfig();

    return Object.freeze({
      id: this.getId(),
      ...parentConfig,
      source: VehicleDetailsSource.id,
      layout: {
        ...parentConfig.layout,
        'icon-image': '{icon}',
      },
    });
  }
}
